import { Selectable } from '../../interface/selectable';
import { CheckState } from '../../enum/check-state.enum';
import { StandardEntity } from '../../engine/standard-entity';
import { CommonUtils } from '../../tool/common-utils';

export class SelectableEntity extends StandardEntity implements Selectable {
  get check(): boolean {
    return this._check;
  }

  set check(value: boolean) {
    this._check = value;
    this.checkState = value ? CheckState.check : CheckState.uncheck;
  }
  private _check: boolean;
  checkState: CheckState;
  enable: boolean;

  rightIcon: string;
  iconColor: string;
  normalizedText: string;
  description: string;
  complements: string;

  constructor(id: string, label: string, display?: 'id' | 'label' | 'full') {
    super(id, label, display);
    this.id = id;
    this.label = label;
    this.checkState = CheckState.uncheck;
    this.normalizedText = CommonUtils.normalize(this.toString(), true);
  }

  override compare(item: any): number {
    return super.compare(item);
  }
}
